import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Card,
  Chip,
  CardContent,
  Stack,Divider
} from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import { Edit, RemoveRedEyeOutlined } from "@mui/icons-material";
// import KuldeviPhotoPop from "./KuldeviPhotoPop";

const LoginHistory = ({ handleEdit, refreshKey }) => {
  const [userHistoryList, setUserHistoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const { company_id } = useSelector((state) => state.GlobalVariables);

  // Filters & sorting
  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("user_name");
  const [sortField, setSortField] = useState("uh.login_time");
  const [sortOrder, setSortOrder] = useState("desc");

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const headers = [
    { label: "S.No.", value: "uh.id" },
    { label: "User Name", value: "user_name" },
    { label: "Role ", value: "uh.role" },
    { label: "City", value: "uh.city" },
    { label: "Longitude", value: "uh.longitude" },
    { label: "Latitude", value: "uh.latitude" },
    { label: "Ip", value: "uh.ip_address" },
    { label: "Login Time", value: "uh.login_time" },
  ];

  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#0c79e6ff",
    color: "white",
    padding: 8,
    textAlign: "center",
    cursor: "pointer",
  };
  const cellStyle = { py: 0.5, textAlign: "center" };

  // ✅ Fetch data dynamically from backend
  const FetchUserLogHistory = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        company_id,
        page: page + 1,
        limit: rowsPerPage,
        search_field: searchType,
        search_value: searchTerm.trim(),
        sort_field: sortField,
        sort_order: sortOrder,
      };

      const result = await configServ.getUserHistory(dataToSend);
      if (result?.success === true) {
        setUserHistoryList(result.data || []);
        setTotal(result.total || 0);
      } else {
        setUserHistoryList([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching  details:", error);
      setUserHistoryList([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // 🚀 Re-fetch whenever filter/sort/pagination changes
  useEffect(() => {
    if (company_id) FetchUserLogHistory();
  }, [
    company_id,
    page,
    rowsPerPage,
    searchTerm,
    searchType,
    sortField,
    sortOrder,
    refreshKey,
  ]);

  // Pagination handlers
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // 🔁 Sorting toggle on header click
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Reset filters
  const handleReset = () => {
    setSearchTerm("");
    setSearchType("user_name");
    setSortField("uh.login_time");
    setSortOrder("desc");
    setPage(0);
  };

  return (
    <>
      {/* <KuldeviPhotoPop
        open={openImagePop}
        onClose={() => setOpenImagePop(false)}
        productId={selectedProductId}
        fetchImages={configServ.getKuldeviPhotos}
      /> */}
      {/* 🔹 Filters Section */}
      <Box
        sx={{
          mt: 2,
          mb: 3,
          p: 2,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          width: "100%",
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          {/* Total */}
          <Grid item xs={12} sm="auto">
            <Typography variant="subtitle1" fontWeight="bold">
              Total: <span style={{ color: "#1976d2" }}>{total}</span>
            </Typography>
          </Grid>

          {/* Search & Filter */}
          <Grid
            item
            xs={12}
            sm
            container
            spacing={1}
            alignItems="center"
            justifyContent={{ xs: "flex-start", sm: "flex-end" }}
          >
            {/* Search By */}
            <Grid item xs={12} sm="auto">
              <FormControl size="small" fullWidth>
                <InputLabel>Search By</InputLabel>
                <Select
                  value={searchType}
                  onChange={(e) => setSearchType(e.target.value)}
                  label="Search By"
                >
                  <MenuItem value="user_name">User Name</MenuItem>
                  <MenuItem value="uh.city">City</MenuItem>
                  {/* <MenuItem value="author_name">Author Name</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            {/* Search Input */}
            <Grid item xs={12} sm="auto">
              <TextField
                size="small"
                fullWidth
                label="Search"
                variant="outlined"
                value={searchTerm}
                onChange={(e) => {
                  setPage(0);
                  setSearchTerm(e.target.value);
                }}
              />
            </Grid>

            {/* Reset Button */}
            <Grid item xs={12} sm="auto">
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                startIcon={<RestartAltIcon />}
                onClick={handleReset}
                fullWidth
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* 🔹 Table Section */}
      <TableContainer
        component={Paper}
        sx={{ display: { xs: "none", md: "block" } }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((header) => {
                const isActive = sortField === header.value;
                return (
                  <TableCell
                    key={header.value}
                    style={headerCellStyle}
                    onClick={() => handleSort(header.value)}
                    sx={{
                      cursor: ![
                        "kd.active",
                        "daily_updates.id",
                        "action",
                      ].includes(header.value)
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {header.label}
                    {!["kd.active", "daily_updates.id", "action"].includes(
                      header.value
                    ) && (
                      <span style={{ marginLeft: 4 }}>
                        {isActive ? (sortOrder === "asc" ? "▲" : "▼") : "⇅"}
                      </span>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : userHistoryList.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  align="center"
                  sx={{ color: "red" }}
                >
                  <b>No Data Found</b>
                </TableCell>
              </TableRow>
            ) : (
              userHistoryList.map((row, rowIndex) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:hover": { backgroundColor: "#f5faff" } }}
                >
                  {/* <TableCell sx={cellStyle}>{row.id}</TableCell> */}
                  <TableCell sx={cellStyle}>
                    {page * rowsPerPage + rowIndex + 1}
                  </TableCell>
                  <TableCell sx={cellStyle}>{row.user_name || "—"}</TableCell>

                  <TableCell sx={cellStyle}>{row.role || "—"}</TableCell>
                  <TableCell sx={cellStyle}>{row.city || "—"}</TableCell>
                  <TableCell sx={cellStyle}>{row.longitude || "—"}</TableCell>
                  <TableCell sx={cellStyle}>{row.latitude || "—"}</TableCell>
                  <TableCell sx={cellStyle}>{row.ip_address || "—"}</TableCell>
                  <TableCell sx={cellStyle}>{row.login_time || "—"}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* Backend Pagination */}
        <TablePagination
          rowsPerPageOptions={[30, 60, 120]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* 📱 Mobile Card View */}
      <Box sx={{ display: { xs: "block", md: "none" }, mt: 2 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : userHistoryList.length === 0 ? (
          <Typography align="center" color="error" py={2}>
            <b>No Data Found</b>
          </Typography>
        ) : (
          userHistoryList.map((row, rowIndex) => (
            <Card
              key={row.id}
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  {page * rowsPerPage + rowIndex + 1}. {row.user_name || "—"}
                </Typography>
                <Chip
                  label={row.role || "—"}
                  color={
                    row.role === "super admin"
                      ? "error"
                      : row.role === "admin"
                      ? "primary"
                      : "default"
                  }
                  size="small"
                />
              </Stack>

              <Divider sx={{ my: 1 }} />

              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">
                    City
                  </Typography>
                  <Typography variant="body2">{row.city || "—"}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">
                    IP Address
                  </Typography>
                  <Typography variant="body2">
                    {row.ip_address || "—"}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">
                    Longitude
                  </Typography>
                  <Typography variant="body2">
                    {row.longitude || "—"}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="caption" color="text.secondary">
                    Latitude
                  </Typography>
                  <Typography variant="body2">{row.latitude || "—"}</Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    Login Time
                  </Typography>
                  <Typography variant="body2">
                    {row.login_time || "—"}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          ))
        )}

        {/* 📄 Backend Pagination for Mobile */}
        <TablePagination
          rowsPerPageOptions={[30, 60, 120]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </>
  );
};

export default LoginHistory;
